import { AccesAction, AccesEtat } from '../../../../app.constants';
 
export class AccesActionRequest<T> {
	acces!: T;
	request!: AccesAction;
	etat!: AccesEtat;
	mode: string | null = null;
}